import React from "react";
import { useLocation } from "react-router-dom";
import { Type, Anchor } from "@ebscois/react-component-library";
import { StyledErrorMsgContainer, StyledActionMsg } from "./styled";
import { errorMappings } from "./constants";

const AuthError = () => {
  const getParamFromUrl = (param, location) => {
    return new URLSearchParams(location.search).get(param);
  };
  const errorCode = getParamFromUrl("errorMsg", useLocation());
  const errMap = errorMappings[errorCode] || errorMappings.default;

  return (
    <>
      <StyledErrorMsgContainer>
        <Type element="h2" fontWeight="bold" data-testid="seamless-title">
          {errMap.errorMsgTitle}
        </Type>
        <Type element="h6" fontWeight="normal">
          {errMap.errorMsgDescription}
        </Type>
      </StyledErrorMsgContainer>
      <StyledActionMsg>
        <Anchor href="/" data-testid="home-anchor">
          {`${errMap.actionMsg}`}
        </Anchor>
      </StyledActionMsg>
    </>
  );
};

export default AuthError;
